export const routes = {
    HOME: '/',
    DEVICE: '/devices',
    VEHICLE: '/vehicles',
    BSD: '/BSD',
    LIVE_MAP: '/map',
    DELAY_ANALYSIS: '/delayAnalysis',
    REPORT: '/reports',
    MASTER:'/vehicleMaster',
    REGION: '/region',
    VIEWMASTER:'/vehicleMasterView',
    CAMERAMASTER:'/cameraMaster',
    PROTOCOL: '/protocol',
    CRON:'/cronTrigger',
    //undo comment to show Trips section
    // TRIP: '/trips'
};

export const developerRoutes = {
    SCHEDULER: 'schedulers',
    POST_ANALYSIS: 'postingAnalysis'
};

export const masterRoutes = {
    CITY: 'city',
    AGENCY: 'agency',
    OPERATOR:'operator',
    DEPOT:'depot',
    OWNER: 'owner'
};

export const extraRoutes = {
    LOGIN: '/login'
};




